import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class CertificationSupplierEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      certification_supplier_id: '',
      anac_code: '',
      expiration_str: '',
      certification: '',
      returning_deadline: '',
      hour_value: '',
      address: '',
      city: '',
      province: '',
      contact_name: '',
      country_list: [],
      country_id: '',
      phone: '',
      email: '',
      observations: '',
      supplier_id: '',
      certification_id: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.locale = getLocale();

    this.editCertificationSupplier = this.editCertificationSupplier.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_certification_supplier.id !== 'undefined' && Array.isArray(newProps.country_list)) {
        this.setState({
          country_list: newProps.country_list,
          anac_code: newProps.data_certification_supplier.anac_code,
          expiration: newProps.data_certification_supplier.expiration_str,
          certificate: newProps.data_certification_supplier.certificate,
          returning_deadline: newProps.data_certification_supplier.returning_deadline,
          hour_value: newProps.data_certification_supplier.hour_value,
          address: newProps.data_certification_supplier.address,
          city: newProps.data_certification_supplier.city,
          province: newProps.data_certification_supplier.province,
          contact_name: newProps.data_certification_supplier.contact_name,
          country_id: newProps.data_certification_supplier.country_id,
          phone: newProps.data_certification_supplier.phone,
          email: newProps.data_certification_supplier.email,
          observations: newProps.data_certification_supplier.observations,
          id: newProps.data_certification_supplier.id,
        });
      }
    }
  }

  // Fetch salvando a edição
  editCertificationSupplier(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      anac_code: this.state.anac_code,
      expiration: this.state.expiration_str,
      certificate: this.state.certificate,
      returning_deadline: this.state.returning_deadline,
      hour_value: this.state.hour_value,
      address: this.state.address,
      city: this.state.city,
      province: this.state.province,
      contact_name: this.state.contact_name,
      country_id: this.state.country_id,
      phone: this.state.phone,
      email: this.state.email,
      observations: this.state.observations,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificado/fornecedor', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.editarCertificadoFornecedor}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.editCertificationSupplier}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Certificacao}:</label>
                    <input type="text" name="certificate" className="form-control" placeholder="" value={this.state.certificate} onChange={this.handleChange.bind(this, 'certificate')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.CodigoANAC}:</label>
                    <input type="text" name="anac_code" className="form-control" placeholder="" value={this.state.anac_code} onChange={this.handleChange.bind(this, 'anac_code')} />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Expiracao}:</label>
                    <InputMask value={this.state.expiration_str}  maskChar={null} name="expiration_str" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration_str')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.ValorHora}:</label>
                    <InputMask value={this.state.hour_value}  maskChar={null} name="hour_value" mask="99999" className="form-control" onChange={this.handleChange.bind(this, 'hour_value')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.PrazoDeCancelamentoComRetornoDoPagamentoEmDias}:</label>
                    <InputMask value={this.state.returning_deadline}  maskChar={null} name="returning_deadline" mask="99999" className="form-control" onChange={this.handleChange.bind(this, 'returning_deadline')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Endereço}:</label>
                    <input type="text" name="address" className="form-control" placeholder={this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.placeholder.EndereçoDoFornecedor} value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Cidade}:</label>
                    <input type="text" name="city" className="form-control" placeholder={this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.placeholder.CidadeDoFornecedor} value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Estado}:</label>
                    <input type="text" name="province" className="form-control" placeholder={this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.placeholder.EstadoDoFornecedor} value={this.state.province} onChange={this.handleChange.bind(this, 'province')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Pais}:</label>
                    <Select
                      className="form-field-name"
                      name="country_id"
                      value={this.state.country_id}
                      searchable={true}
                      placeholder={this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.placeholder.SelecionePais}
                      onChange={this.handleSelectChange.bind(this, 'country_id')}
                      options={this.state.country_list}
                    />    
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.ContatoNome}:</label>
                    <input type="text" name="contact_name" className="form-control" placeholder="" value={this.state.contact_name} onChange={this.handleChange.bind(this, 'contact_name')} />
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Telefone}:</label>
                    <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder={this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.placeholder.TelefoneDoFornecedor} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Email}:</label>
                    <input type="text" name="email" className="form-control" placeholder={this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.placeholder.EmailDoFornecedor} value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>{this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.Observacoes}:</label>
                    <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Certificados.EditarCertificado.tabFornecedoresDesteCertificado.formularioEditarFornecedor.botaoSalvarFornecedor}</button>
                </div>
              </div>
            </form>    
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default CertificationSupplierEditModal;



// WEBPACK FOOTER //
// ./src/Components/CertificationSuppliers/Elements/CertificationSupplierEditModal.js